import { render, staticRenderFns } from "./LazyImg.vue?vue&type=template&id=04b264dc"
import script from "./LazyImg.vue?vue&type=script&lang=js"
export * from "./LazyImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports